/* create by dannyliu */
// import { BrowserRouter, history } from 'react-router-dom';


// 获取正常模式的路由地址
export function getNormalPageUrl(nbId, noteId) {
  if (noteId) {
    return `/notebooks/${nbId}/notes/${noteId}`;
  }
  if (nbId) {
    return `/notebooks/${nbId}`;
  }
  return '/';
}

// 获取写作模式的路由地址
export function getWritingPageUrl(nbId, noteId) {
  return `/notebooks/${nbId}/notes/${noteId}/writing`;
}

// 获取回收站的路由地址
export function getRecyclePageUrl(noteId) {
  if (noteId) {
    return `/recycle/${noteId}`;
  }
  return '/recycle';
}

// 获取历史版本的路由地址
export function getHistoryPageUrl(nbId, noteId) {
  return `/notebooks/${nbId}/notes/${noteId}/history`;
}

// 获取付费文章设置页面路由
export function getPNSettingPageUrl(nbId, noteId) {
  return `/notebooks/${nbId}/notes/${noteId}/pnsetting`;
}

// 获取文章发布后的链接
export function getNoteSharedUrl(slug) {
  const origin = process.env.ENVIRONMENT === 'development' ? 'http://localhost:3000' : window.location.origin;
  return `${origin}/p/${slug}?v=${new Date().getTime()}`;
}

// 获取新建专题的页面url
export function getNewCollectionPageUrl() {
  return `${window.location.origin}/collections/new`;
}

// const getAction = function (isReplace) {
//   return isReplace ? 'replace' : 'push';
// };
// // 跳转至三栏页面
// export function redirectToNormalPage(nbId, noteId, isReplace) {
//   history[getAction(isReplace)](getNormalPageUrl(nbId, noteId));
// }

// // 跳转至写作模式页面
// export function redirectToWritingPage(nbId, noteId, isReplace) {
//   history[getAction(isReplace)](this.getWritingPageUrl(nbId, noteId));
// }

// // 跳转至回收站页面
// export function redirectToRecyclePage(noteId, isReplace) {
//   history[getAction(isReplace)](getRecyclePageUrl(noteId));
// }

// // 跳转至历史版本页面
// export function redirectToHistoryPage(nbId, noteId, isReplace) {
//   history[getAction(isReplace)](getHistoryPageUrl(nbId, noteId));
// }



// WEBPACK FOOTER //
// ./src/utils/urlHelper.js